import ClipboardJS from 'clipboard';
import { ElNotification } from 'element-plus';
import { App, Plugin } from 'vue';

interface Options {
    // 可选的配置项
    successMessage?: string;
    errorMessage?: string;
}

export const ClipboardPlugin: Plugin = {
    install(app: App, options: Options = {}) {
        // 设置默认的配置项
        const { successMessage = '已复制到剪贴板', errorMessage = '复制失败，请手动复制' } = options;

        // 注册全局指令 v-clipboard，用于绑定复制剪贴板功能到 DOM 元素上
        app.directive('clipboard', {
            mounted(el, binding) {
                // 获取需要复制的文本
                const copyText = binding.value;

                // 创建 Clipboard.js 实例，并绑定到 DOM 元素上
                const clipboard = new ClipboardJS(el, {
                    text: () => copyText
                });

                // 监听复制成功事件，并弹出成功消息
                clipboard.on('success', () => {
                    ElNotification({
                        message: successMessage,
                        type: 'success',
                    })
                });

                // 监听复制失败事件，并弹出失败消息
                clipboard.on('error', () => {
                    ElNotification({
                        message: errorMessage,
                        type: 'error',
                    })
                });
                el.__clipboard__ = clipboard;
            },
            unmounted(el) {
                // 在 unmounted 阶段销毁剪贴板实例
                const clipboard = el.__clipboard__;
                if (clipboard) {
                    clipboard.destroy();
                    delete el.__clipboard__;
                }
            }
        });
    }
};

